var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 22H7C6.59 22 6.25 21.66 6.25 21.25C6.25 20.84 6.59 20.5 7 20.5H17C17.41 20.5 17.75 20.84 17.75 21.25C17.75 21.66 17.41 22 17 22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.35 5.52001L16.35 8.38001C15.82 8.76001 15.06 8.53001 14.83 7.92001L12.94 2.88001C12.62 2.01001 11.39 2.01001 11.07 2.88001L9.17 7.91001C8.94 8.53001 8.19 8.76001 7.66 8.37001L3.66 5.51001C2.86 4.95001 1.8 5.74001 2.13 6.67001L6.29 18.32C6.43 18.72 6.81 18.98 7.23 18.98H16.76C17.18 18.98 17.56 18.71 17.7 18.32L21.86 6.67001C22.2 5.74001 21.14 4.95001 20.35 5.52001ZM14.5 14.75H9.5C9.09 14.75 8.75 14.41 8.75 14C8.75 13.59 9.09 13.25 9.5 13.25H14.5C14.91 13.25 15.25 13.59 15.25 14C15.25 14.41 14.91 14.75 14.5 14.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLeaderboard);
export default __webpack_public_path__ + "static/media/menu-leaderboard.53ff20696d23689ffa256c9e839d51c7.svg";
export { ForwardRef as ReactComponent };